// extracted by mini-css-extract-plugin
export default {"row-info":"ModalInfoFace_row-info__vLE-z","label-info":"ModalInfoFace_label-info__N20RD","content-info":"ModalInfoFace_content-info__H-q+e","image":"ModalInfoFace_image__0zS-z"};